// Initialize Application Insights when your app starts
// Add this to your main App.tsx or index.tsx

import { initAppInsights } from './appInsights';

// Call this once when your app starts
export const setupApplicationInsights = () => {
  // Only initialize if connection string is available
  if (window.config?.APPLICATION_INSIGHTS_CONNECTION_STRING) {
    initAppInsights();
    console.log('Application Insights initialized for exception tracking');
  } else {
    console.warn('Application Insights connection string not found - exception tracking disabled');
  }
};

// Export for easy use
export default setupApplicationInsights;